// UserModal.js
import React from 'react';
import './AccountsModal.css';

const AccountsModal = ({ isOpen, onClose }) => {
  if (!isOpen) {
    return null;
  }

  return (
    <div className="accounts-modal">
      <div className="modal-content">
        <h2 className='title'>Accounts Modal</h2>
        {/* Add your modal content here */}
        <button onClick={onClose}>Close Modal</button>
      </div>
    </div>
  );
};

export default AccountsModal;
